import { Box, Image, VStack, Text } from "@chakra-ui/react";
import { BaseBlockProps } from "./types";

interface ImageContent {
  image_url?: string;
  url?: string;
  title?: string;
  subtitle?: string;
  alt?: string;
}

export const ImageBlock = ({ block }: BaseBlockProps) => {
  const content = block.content as ImageContent | string | undefined;

  const imageUrl =
    typeof content === "object"
      ? content?.image_url || content?.url
      : typeof content === "string"
        ? content
        : undefined;

  const title = typeof content === "object" ? content?.title : block.title;
  const subtitle = typeof content === "object" ? content?.subtitle : undefined;
  const alt = typeof content === "object" ? content?.alt : title || "Image";

  if (!imageUrl) return null;

  return (
    <Box>
      <Image
        src={imageUrl}
        alt={alt}
        borderRadius="component.md"
        maxH="200px"
        w="full"
        objectFit="cover"
        border="1px solid"
        borderColor="border.default"
      />
      {(title || subtitle) && (
        <VStack align="start" spacing={0} mt="sm">
          {title && (
            <Text fontSize="xs" fontWeight="600" color="text.body.primary">
              {title}
            </Text>
          )}
          {subtitle && (
            <Text fontSize="xs" color="text.body.secondary">
              {subtitle}
            </Text>
          )}
        </VStack>
      )}
    </Box>
  );
};
